import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useSetPortfolioHome = () => {
  const mutation = trpc.portfolioManagement.items.setHomeSelection.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, setHome: action.execute };
};
